import axios from "axios";
import config from "../../../settings/config";
import { handleError } from "../../../network/servicErrorHandling";

async function addComment(params, id) {
  axios.defaults.headers.common["Authorization"] = localStorage.getItem(
    `${window.location.hostname}_token`
  );
  return Promise.resolve().then((v) =>
    axios
      .post(`${config.baseUrl}v1/products/${id}/comments`, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function addShopComment(params, id) {
  axios.defaults.headers.common["Authorization"] = localStorage.getItem(
    `${window.location.hostname}_token`
  );
  return Promise.resolve().then((v) =>
    axios
      .post(`${config.baseUrl}v1/shops/${id}/comments`, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function deleteComment(id) {
  return Promise.resolve().then((v) =>
    axios
      .delete(`${config.baseUrl}v1/socials/comments/${id}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function reportComment(id) {
  return Promise.resolve().then((v) =>
    axios
      .post(`${config.baseUrl}v1/socials/comments/${id}/report`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function managementReply(uid, comment) {
  return Promise.resolve().then((v) =>
    axios
      .post(`${config.baseUrl}v1/socials/comments/${uid}/reply`, {
        comment: comment,
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

export {
  addComment,
  deleteComment,
  reportComment,
  managementReply,
  addShopComment,
};
